export const chase = false;
export const clouds = true;
export const zoomed = false;
export const cars = true;
export const night = false;
export const map = {
  rows: 10,
  coins: 3
}